import { Link } from 'gatsby'
import React from 'react'
import * as styles from "../styles/footer.module.css"
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

export default function Footer() {
    const breakpoints = useBreakpoint();
    if (breakpoints.tablet) {
        return (
            <footer>
                <div className={styles.footerContainerMobile}>
    
                    <div className={styles.footerLogo}>
                        <img src="images/icon.png" alt="Logo" className="logo" />
                    </div>
                    <center className={styles.footerDescriptionMobile}>
                        <p>
                            GEEKAY Esports is an organization under Game King LLC. Located in the MIddle East, it consists of multiple squads, coaches and professionals that manager and overview the organization and standings of the Geekay Name.
                        </p>
                    </center>
                    <center className={styles.footerContactMobile}>
                        <p>
                            Location & Contact Information<br></br>
                            Post Box No. 2589, 1 19D Street, Al Aweer, Industrial Area First, - Dubai<br></br>
                            +971-4-3361706
                        </p>
                    </center>
                    <center className={styles.footerListContainerMobileGroup}>
                    <center className={styles.footerListContainerMobile}>
                        <div className={styles.footerListTitle}>
                            <h4>Menu</h4>
                        </div>
                        <div className={styles.footerList}>
                            <Link className={styles.footerListItem} to="/">Home</Link>
                            <Link className={styles.footerListItem} to="/about">About Us</Link>
                            <a className={styles.footerListItem} href="https://www.geekaygames.com/">Store</a>
                        </div>
                    </center>
                    <center className={styles.footerListContainerMobile}>
                        <div className={styles.footerListTitle}>
                            <h4>Social Media</h4>
                        </div>
                        <div className={styles.footerList}>
                            {/* <a className={styles.footerListItem} href="#">Twitch</a> */}
                            <a className={styles.footerListItem} href="https://www.facebook.com/Geekaygames">Facebook</a>
                            <a className={styles.footerListItem} href="https://twitter.com/Geekay_Esports">Twitter</a>
                            <a className={styles.footerListItem} href="https://www.youtube.com/channel/UCtLzek4p-sXg22igOdwKc2w">YouTube</a>
                        </div>
                    </center>
                    </center>
    
                </div>
                <div className={styles.copyrightMobile}>
                    <div>Copyright &copy; 2021 &nbsp;</div>
                    <a href="https://www.geekaygames.com/">Game King LLC.</a> 
                    <div>&nbsp; All Rights Reserved.</div>
                </div>
            </footer>
        )
    } else {
        return (
            <footer>
                <div className={styles.footerContainer}>
    
                    <div className={styles.footerLogo}>
                        <img src="images/icon.png" alt="Logo" className="logo" />
                    </div>
                    <center className={styles.footerDescription}>
                        <p>
                            GEEKAY Esports is an organization under Game King LLC. Located in the MIddle East, it consists of multiple squads, coaches and professionals that manager and overview the organization and standings of the Geekay Name.
                        </p>
                    </center>
                    <center className={styles.footerContact}>
                        <p>
                            Location & Contact Information<br></br>
                            Post Box No. 2589, 1 19D Street, Al Aweer, Industrial Area First, - Dubai<br></br>
                            +971-4-3361706
                        </p>
                    </center>
                    <center className={styles.footerListContainer}>
                        <div className={styles.footerListTitle}>
                            <h4>Menu</h4>
                        </div>
                        <div className={styles.footerList}>
                            <Link className={styles.footerListItem} to="/">Home</Link>
                            <Link className={styles.footerListItem} to="/about">About Us</Link>
                            <a className={styles.footerListItem} href="https://www.geekaygames.com/">Store</a>
                        </div>
                    </center>
                    <center className={styles.footerListContainer}>
                        <div className={styles.footerListTitle}>
                            <h4>Social Media</h4>
                        </div>
                        <div className={styles.footerList}>
                            {/* <a className={styles.footerListItem} href="#">Twitch</a> */}
                            <a className={styles.footerListItem} href="https://www.facebook.com/Geekaygames">Facebook</a>
                            <a className={styles.footerListItem} href="https://twitter.com/Geekay_Esports">Twitter</a>
                            <a className={styles.footerListItem} href="https://www.youtube.com/channel/UCtLzek4p-sXg22igOdwKc2w">YouTube</a>
                        </div>
                    </center>
    
                </div>
                <div className={styles.copyright}>
                    <div>Copyright &copy; 2021 &nbsp;</div>
                    <a href="https://www.geekaygames.com/">Game King LLC.</a> 
                    <div>&nbsp; All Rights Reserved.</div>
                </div>
            </footer>
        )
    }
}
